










































































































import Vue from "vue";
export default Vue.extend({
  name: "CardProject",
  props: {
    listProject: Array,
  },
  data: () => ({
    sheet: false,
    itemSelected: null,
    carouselModel: 0,
  }),
  computed: {
    carouselHeight(): number {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 300;
        case "lg":
          return 700;
        case "xl":
          return 900;
        default:
          return 480;
      }
    },
    imgHeight(): number {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 400;
        case "lg":
          return 600;
        case "xl":
          return 900;
        default:
          return 480;
      }
    },
  },
});
